import datagram_logo from './datagram_logo.png';
import helix_logo from './helix_logo.png';
import unstoppable_domains_logo from './unstoppable_domains_logo.png';

export const partners = {
  datagram_logo: datagram_logo.src,
  helix_logo: helix_logo.src,
  unstoppable_domains_logo: unstoppable_domains_logo.src,
};
